import { render, staticRenderFns } from "./sku_table.vue?vue&type=template&id=25b8994e"
import script from "./sku_table.vue?vue&type=script&lang=js"
export * from "./sku_table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports